import { render, staticRenderFns } from "./fin-manager-review.vue?vue&type=template&id=fda65ec6&scoped=true"
import script from "./fin-manager-review.vue?vue&type=script&lang=js"
export * from "./fin-manager-review.vue?vue&type=script&lang=js"
import style0 from "./fin-manager-review.vue?vue&type=style&index=0&id=fda65ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda65ec6",
  null
  
)

export default component.exports